import merge from "deepmerge";
import { useRouter } from "next/router";
import { useEffect, useMemo, useReducer } from "react";

const defaultInitialState = { nextStep: 1, formData: {}, clearError: true };
const reducer = (state, action) => {
  const newState = { ...state };
  const { formData = {}, clearError = true } = action;
  switch (action.type) {
    case "set":
      return merge(newState, { formData, clearError });
    case "next":
      return merge(newState, {
        nextStep: state.nextStep + 1,
        formData,
        clearError,
      });
    case "prev":
      return merge(newState, {
        nextStep: state.nextStep - 1,
        formData,
        clearError,
      });
    case "step":
      return merge(newState, { nextStep: action.step });
    case "reset":
      return defaultInitialState;
    default:
      return state;
  }
};

const defaultOptions = { maxStep: 3, completeStep: null };

export function useStep(initialState = {}, options = {}) {
  options = { ...defaultOptions, ...options };
  const [state, dispatch] = useReducer(reducer, {
    ...defaultInitialState,
    ...initialState,
  });
  const router = useRouter();

  const step = useMemo(() => {
    const step = router.query?.step?.toString();
    if (!step) return 1;
    const matches = step.match(/^step(\d)$/);
    const stepNum = Number(matches[1]);
    if (stepNum <= options.maxStep) {
      return stepNum;
    } else {
      return 1;
    }
  }, [router.query, options.maxStep]);

  useEffect(() => {
    // ブラウザバック
    router.beforePopState(({ as }) => {
      const match = as.match(/step(?<step>\d)/);
      const nextStep = (() => {
        const num = Number(match?.groups.step);
        if (isNaN(num)) return 1;
        return num;
      })();
      if (match) {
        // completeStepまでいったらブラウザバックさせない
        if (options.completeStep && state.nextStep === options.completeStep) {
          window.history.go(1);
          return false;
        }
        if (state.nextStep > nextStep) {
          dispatch({ type: "prev" });
        } else if (state.nextStep < nextStep) {
          dispatch({ type: "next" });
        } else if (state.nextStep === nextStep) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    });
    return () => {
      router.beforePopState(() => true);
    };
  }, [state.nextStep, options.completeStep]);

  return { step, state, dispatch };
}
